import type { Permission } from '@/model/workspace/permission.generated';
import { ROUTES } from '@/shared/constants/routes';
import { Loader } from '@/view/shared/Loader';
import { usePermissions } from '@/viewmodel/features/project';
import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

interface Props {
  children: ReactNode;
  permission: Permission;
  redirectTo?: string;
}

export function ProtectedRoutePermission({
  children,
  permission,
  redirectTo = ROUTES.DATASET,
}: Readonly<Props>) {
  const { can, isLoading } = usePermissions();

  if (isLoading) return <Loader />;
  if (!can(permission)) return <Navigate to={redirectTo} />;

  return <>{children}</>;
}
